export default __webpack_public_path__ + "static/assets/8a81f6b82f7a2e6efdacddcae9154c3a.png";